import { Box, Button, Grow, IconButton, Modal, Slide, styled, Typography } from "@mui/material";
import React from "react";
import DatePicker from "react-datepicker";
import { ReactComponent as LeftArrowIcon } from "../../../../../assets/orderClient/cal_left_arrow.svg";
import { ReactComponent as RightArrowIcon } from "../../../../../assets/orderClient/cal_right_arrow.svg";
import "./datePickerStyle.css";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB";
import { getYear } from "date-fns";
import { ReactComponent as Cross } from "../../../../../assets/icons/update_img_icons/cross.svg";
import { ReactComponent as ArrowDown } from "../../../../../assets/orderClient/downArrow.svg";
import { Opacity } from "@mui/icons-material";
registerLocale("en-GB", enGB);



const StyledButton = styled(Button)({
  backgroundColor: "#50C878",
  width: "100%",
  height: "2vw",
  padding: ".45vw 2vw",
  color: "#000000",
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: ".7vw",
  lineHeight: "100%",
  borderRadius: ".3vw",
  "&:hover": {
    backgroundColor: "#50C878",
    color: "#000000",
  },
  "&:disabled": {
    backgroundColor: "#555555",
    color: "#000000",
    Opacity : 0.5
  },
});

const DatePickerComp = ({ startDate, onChange, endDate, handleClear, open, handleClose, handleApply, useIn, allowSundays = false, maxDate }) => {
  const years = Array.from({ length: getYear(new Date()) - 1989 }, (_, i) => 1990 + i);

  const isWeekday = (date) => {
    if (allowSundays) return true;
    const day = date?.getDay();
    return day !== 0;
  };

  const calendarMonth = {
    color: "#293050",
    fontFamily: "Inter",
    fontWeight: "600",
    fontSize: ".85vw",
    lineHeight: "20px",
    letterSpacing: "-0.18px",
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "transparent",
        },
      }}
    >
      <Grow in={open}>
        <Box
          sx={{
            position: "fixed",
            top: useIn === "FilterModal" ? "auto" : useIn === "IconChild" ? "9vw" : "50%",
            bottom: useIn === "FilterModal" ? "16px" : "auto",
            transform: useIn === "IconChild" || useIn === "FilterModal" ? "none" : "translateY(-50%)",
            right: useIn === "FilterModal" ? "415px" : "1.6vw",
            zIndex: "20",
            width: "16vw",
            height: useIn === "FilterModal" ? "auto" : "24vw",
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              color: "black",
              borderRadius: ".4vw",
              padding: ".8vw .6vw",
              width: "100%",
              height: "2.4vw",
              textAlign: "center",
              marginBottom: ".25vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ ...calendarMonth, flex: 1 }}>
              {startDate
                ? `${startDate?.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "2-digit",
                  })} - ${
                    endDate
                      ? endDate?.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "2-digit",
                        })
                      : "select end date"
                  }`
                : "Select date range"}
            </Typography>
            {startDate && (
              <IconButton aria-label="Close" onClick={handleClear}>
                <Cross />
              </IconButton>
            )}
          </Box>

          <Box
            className="order-calendar"
            // width="100%"
            // height="90%"
            display="flex"
            alignItems="center"
            flexDirection="column"
            gap=".5vw"
            backgroundColor="white"
            borderRadius=".4vw"
            padding="1vw"
            width="100%"
            // height='100%'
          >
            <DatePicker
              selected={startDate}
              onChange={onChange}
              startDate={startDate}
              endDate={endDate}
              locale="en-GB"
              selectsRange
              inline
              fixedHeight={useIn === "FilterModal"}
              filterDate={isWeekday}
              maxDate={maxDate}
              className="custom-datepicker"
              renderCustomHeader={({ date, changeYear, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                <div
                  style={{
                    // width: "100%",
                    // height:"100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: ".5vw .75vw",
                    fontSize: ".8vw",
                    fontWeight: "bold",
                    color: "#222",
                    width: "100%",
                    height: "60%",
                  }}
                >
                  {/* Month & Year Selection */}
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "center",
                      gap: ".3vw",
                    }}
                  >
                    <Typography sx={{ ...calendarMonth }}>{date.toLocaleDateString("en-GB", { month: "long" })}</Typography>
                    <div style={{ position: "relative" }}>
                      <select
                        className="year-selection"
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(Number(value))}
                        style={{
                          fontSize: ".75vw",
                          fontWeight: "600",
                          border: "none",
                          background: "none",
                          cursor: "pointer",
                        }}
                      >
                        {years?.map((year) => (
                          <option className="year-opt" key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                      <Box className="custom-arrow">
                        <ArrowDown />
                      </Box>
                    </div>
                  </div>

                  {/* Navigation Buttons */}
                  <div style={{ display: "flex", gap: ".8vw" }}>
                    <button
                      onClick={decreaseMonth}
                      disabled={prevMonthButtonDisabled}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "1vw",
                        cursor: prevMonthButtonDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      <LeftArrowIcon />
                    </button>
                    <button
                      onClick={increaseMonth}
                      disabled={nextMonthButtonDisabled}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "1vw",
                        cursor: nextMonthButtonDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      <RightArrowIcon />
                    </button>
                  </div>
                </div>
              )}
            />

            <StyledButton
            disabled = {!endDate}
              onClick={() => {
                handleApply();
                handleClose();
              }} 
              
            >
              Apply
            </StyledButton>
          </Box>
        </Box>
      </Grow>
    </Modal>
  );
};

export default DatePickerComp;
